export default __webpack_public_path__ + "aaa7079ae8f8d2ef829a89abe9ef28ad.hdr";